import { render, staticRenderFns } from "./ShopControl.vue?vue&type=template&id=089edb6b&"
import script from "./ShopControl.vue?vue&type=script&lang=js&"
export * from "./ShopControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports